// frontend/src/landing/components/Card.tsx
import React from "react";

type Props = {
  title: string;
  children?: React.ReactNode;
  meta?: string;
  icon?: React.ReactNode;
  className?: string;
};

export default function Card({ title, children, meta, icon, className }: Props) {
  return (
    <div className={`zg-card ${className ?? ""}`.trim()}>
      <div style={{ display: "flex", gap: 12, alignItems: "flex-start" }}>
        {icon && (
          <div style={{ width: 28, height: 28, flex: "0 0 auto", opacity: 0.9 }}>
            {icon}
          </div>
        )}
        <div style={{ minWidth: 0 }}>
          <div className="zg-card-title">{title}</div>
          {meta && <div className="zg-card-meta">{meta}</div>}
          {children && <div style={{ marginTop: 10 }}>{children}</div>}
        </div>
      </div>
    </div>
  );
}